export enum UserPreferencesStrings {
    gameCategories = 'Géneros de juegos',
    opportunities = 'Oportunidades de interés',
    platforms = 'Plataformas'
}